//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import DispatchRequestBatchListView from '@/views/Warehouse/WhDispatchRequestBatch/list'
import DispatchRequestBatchCreateView from '@/views/Warehouse/WhDispatchRequestBatch/create'
import DispatchRequestBatchReceptionView from '@/views/Warehouse/WhDispatchRequestBatch/reception'
import DispatchRequestBatchUpdateView from '@/views/Warehouse/WhDispatchRequestBatch/update'

/**
 *
 */
export default {
    path: 'dispatch_request_batches',
    component: ModuleLayout,
    children: [
        {
            name: 'dispatch-request-batch',
            path: '',
            component: DispatchRequestBatchListView,
        },
        {
            name: 'dispatch-request-batch-create',
            path: 'new',
            component: DispatchRequestBatchCreateView,
            meta: {
                title: 'Crear lote de despacho',
            },
        },
        {
            name: 'dispatch-request-batch-update',
            path: ':id',
            component: DispatchRequestBatchUpdateView,
            meta: {
                title: 'Detalle de lote de despacho',
            },
        },
        {
            name: 'dispatch-request-batch-reception',
            path: ':id/reception',
            component: DispatchRequestBatchReceptionView,
            meta: {
                title: 'Recepción de lote de despacho',
            },
        },
    ],
    meta: {
        title: 'Lotes de despacho',
    },
}
